export default __webpack_public_path__ + "static/media/steroids.1b05d9e2.svg";